import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'
import { stat } from 'fs';
Vue.use(VueAxios, axios)


const state = {
    accessToken:(this.accessToken === undefined || this.accessToken === null) ? window.localStorage.getItem('setAccessToken') : this.accessToken,
    userInfo : (this.userInfo === undefined || this.userInfo === null) ? JSON.parse( window.localStorage.getItem('setUserInfo')) : this.userInfo,
    coachType: (this.coachType === undefined || this.coachType === null) ? window.localStorage.getItem('setCoachType') : this.coachType,
    authFlag : (this.authFlag === undefined || this.authFlag === null) ? window.localStorage.getItem('setAuthFlag') : false,
    classImagePath : (this.classImagePath === undefined || this.classImagePath === null ) ? window.localStorage.getItem('setClassImagePath') : this.classImagePath,
    feedbackScore: (this.feedbackScore === undefined || this.feedbackScore===null) ? window.localStorage.getItem('setFeedBackSocre') : this.feedbackScore,
    backKey : (this.backKey === undefined || this.backKey === null ) ? window.localStorage.getItem('setBackKey') : this.backKey,
    bearerPath :''
}

const mutations = {
    setAccessToken (state , { tokenObj }) {
        window.localStorage.setItem('setAccessToken',"bearer " + tokenObj);
        state.accessToken = "bearer " + tokenObj;
    },
    setUserInfo (state, { userObj} ) {
        window.localStorage.setItem('setUserInfo',JSON.stringify(userObj));
        state.userInfo = userObj;
    },
    setBearerPath (state , { bearerObj} ) {
        state.bearerPath = bearerObj;
    },
    setCoachType(state, {coachObj}) {
        window.localStorage.setItem('setCoachType',coachObj);
       
        state.coachType = coachObj;
    },
    setAuthFlag(state, {flagObj}) {
   
        window.localStorage.setItem('setAuthFlag',flagObj);
        state.authFlag = flagObj;
    },
    setClassImagePath (state, {classImagePathObj}) {
        window.localStorage.setItem('setClassImagePath',classImagePathObj);
        state.classImagePath = classImagePathObj;
    },
    setFeedBackSocre ( state, {feedbackObj}) {

        window.localStorage.setItem('setFeedBackSocre',feedbackObj);
        state.feedbackScore = feedbackObj;
    },
    removeAllData ( state, {actionObj}) {
        state.feedbackScore = undefined;
        state.coachType = undefined;
        state.userInfo = undefined;
        state.authFlag = undefined;
        state.accessToken = undefined;
        window.localStorage.removeItem('setCoachType');
        window.localStorage.removeItem('setAuthFlag');
        window.localStorage.removeItem('setFeedBackSocre');
        window.localStorage.removeItem('setUserInfo');
        window.localStorage.removeItem('setAccessToken');
        window.localStorage.removeItem("classImagePathStr");
        window.localStorage.removeItem("courseCodeStr");
    },
    setBackKey(state, {backKeyObj}) {
        window.localStorage.setItem('setBackKey',backKeyObj);
        state.backKey = backKeyObj;
    }
}

const actions = {
    tokenTrigger ({ commit , state },obj ) {
        commit('setAccessToken',{tokenObj:obj});
    },
    userTrigger ({ commit , state } , obj) {
        commit('setUserInfo',{userObj:obj});
    },
    bearerPathTrigger({commit , state } , obj) {
        commit('setBearerPath',{bearerPath:obj});
    },
    coachTrigger({commit , state},obj) {
        commit('setCoachType',{coachObj:obj});
    },
    authFlagTrigger({commit, state}, obj) {
        commit('setAuthFlag',{flagObj:obj});
    },
    classImagePathTrigger ({commit,state},obj) {
        commit('setClassImagePath',{classImagePathObj:obj});
    },
    feedBackSocreTrigger ({commit,state},obj) {
        commit('setFeedBackSocre',{feedbackObj:obj});
    },
    logoutRemoveTrigger ({commit,state},obj) {
        commit('removeAllData',{actionObj:obj});
    },
    backTrigger({commit,state},obj) {
        commit('setBackKey',{backKeyObj:obj});
    }

}

const getters = {

}



export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/store.js